import { render, staticRenderFns } from "./ActUpdatePage.vue?vue&type=template&id=b128da4e"
import script from "./ActUpdatePage.vue?vue&type=script&lang=js"
export * from "./ActUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports